import { Text, VStack } from "native-base";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import Stars from "../../../../components/stars";
import NewTextAreaField from "../../../../components/textArea/newTextArea";

export const RateExperienceModal = ({
  eventName,
  reviewData,
  setReviewData,
  childref,
  forceRemount,
}) => {
  const onStarsChange = (value) => {
    let data = { ...reviewData };
    data["rating"] = value;
    setReviewData(data);
  };

  const onReviewChange = (input) => {
    let value = input.target.value;
    let data = { ...reviewData };
    data["review"] = value;
    setReviewData(data);
  };

  return (
    <VStack>
      <VStack space={2}>
        <Text
          fontSize={COMMONFONTSIZE.EXTRA_LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_LARGE_FONT_WEIGHT}
        >
          {eventName}
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
        >
          Your service rating
        </Text>
      </VStack>
      <Stars onChange={onStarsChange} size="40px" stars={reviewData.rating} />
      <NewTextAreaField
        name="review"
        value={reviewData.review}
        onChange={onReviewChange}
        placeholder="Rate your experience"
        ref={childref}
        forceRemount={forceRemount}
      />
    </VStack>
  );
};
